import gql from 'graphql-tag'

export const GET_USER_EMAIL_BY_RESET_TOKEN = gql`
query ($resetPasswordToken: String) {
  user(resetPasswordToken: $resetPasswordToken) {
    id
    email
  }
}
`
export default {
  GET_USER_EMAIL_BY_RESET_TOKEN
}
